<div [dlNodeVolger]="node" [cy]="cy" ankertype="rechtsonder" [offset]="{x: 5, y: 5}" [volgFormaat]="false" [schaalMetZoom]="false" [zichtbaarAls]="modelcanvas.nodeOverlaysZichtbaar" class="dl-nodemenu__holder" (pointerover)="opItemHover($event)" (pointerleave)="opMenuVerlaten()">
    <ul class="dl-nodemenu">
        @if (!condtag && effectiefModelleerniveau >= 30) {
            <li class="dl-nodemenu__item" (click)="toggleSubmenu('quantity_sub_quantity_space_menu')" title="{{ 'QS_SUBMENU' | translate }}">
                <a class="quantity_space"></a>
            </li>
        }
        @if (!condtag || condtag.state === 'cons') {
            <li class="dl-nodemenu__item" (click)="toggleSubmenu('influence_menu')" title="{{ 'INFLUENCE_SUBMENU' | translate }}">
                <a class="influencemenu"></a>
            </li>
        }
        @if (effectiefModelleerniveau >= 40) {
            <li class="dl-nodemenu__item" (click)="toggleSubmenu('quantity_ineq_menu')" title="{{ 'INEQ_SUBMENU' | translate }}">
                <a class="equal"></a>
            </li>
        }
        @if (effectiefModelleerniveau >= 40) {
            <li class="dl-nodemenu__item" (click)="toggleSubmenu('q_calc_menu')" title="{{ 'CALC_SUBMENU' | translate }}">
                <a class="q_calc_plusmin"></a>
            </li>
        }
        @if (!condtag && effectiefModelleerniveau >= 30) {
            <li class="dl-nodemenu__item" (click)="toggleSubmenu('quantity_exogeen_menu')">
                <a class="q_exo_menuitem q_exo_sin" title="{{ 'EXO_SUBMENU' | translate }}"></a>
            </li>
        }
        @if (!condtag && effectiefModelleerniveau >= 40) {
            <li class="dl-nodemenu__item" data-uitleg="quantity_allvalues" (click)="uitvoerToggleAllewaarden()" title="{{ 'ADD_ALLEWAARDEN' | translate }}">
                <a class="alle_waarden"></a>
            </li>
        }
        @if (!condtag) {
            <li class="dl-nodemenu__separator dl-nodemenu__item"></li>
            <li class="dl-nodemenu__item" (click)="uitvoerEditBallon()" title="{{ 'BALLON.BTN_TITLE' | translate }}">
                <a class="fa_item"><span class="fa-regular fa-comment"></span></a>
            </li>
        }
    </ul>
    @if (actievSubmenu() === 'quantity_sub_quantity_space_menu') {
        <ul class="dl-nodemenu__submenu">
            @if (!condtag) {
                <li class="dl-nodemenu__item" data-uitleg="quantity_space_point" [class.selectedMenuItem]="isActiefInitAddActie('quantity_space', 'quantity_space_point')" (click)="uitvoerInitAddAction({type:'quantity_space', element:'quantity_space_point'})" title="{{ 'ADD_QPOINT' | translate }}">
                    <a class="point"></a>
                </li>
                <li class="dl-nodemenu__item" data-uitleg="quantity_space_interval" [class.selectedMenuItem]="isActiefInitAddActie('quantity_space', 'quantity_space_interval')" (click)="uitvoerInitAddAction({type:'quantity_space', element:'quantity_space_interval'})" title="{{ 'ADD_INTERVAL' | translate }}">
                    <a class="interval"></a>
                </li>
            }
        </ul>
    }
    @if (actievSubmenu() === 'influence_menu') {
        <ul class="dl-nodemenu__submenu">
            @if (effectiefModelleerniveau >= 40 && (!condtag || condtag.state === 'cons')) {
                <li class="dl-nodemenu__item" data-uitleg="influence_positive" [class.selectedMenuItem]="isActiefInitAddActie('influence_positive')" (click)="uitvoerInitAddAction({type:'influence_positive'})" title="{{ 'ADD_INF_POS' | translate }}">
                    <a class="influence_positive"></a>
                </li>
                <li class="dl-nodemenu__item" data-uitleg="influence_negative" [class.selectedMenuItem]="isActiefInitAddActie('influence_negative')" (click)="uitvoerInitAddAction({type:'influence_negative'})" title="{{ 'ADD_INF_NEG' | translate }}">
                    <a class="influence_negative"></a>
                </li>
            }
            @if (!condtag || condtag.state === 'cons') {
                <li class="dl-nodemenu__item" data-uitleg="proportionality_positive" [class.selectedMenuItem]="isActiefInitAddActie('proportionality_positive')" (click)="uitvoerInitAddAction({type:'proportionality_positive'})" title="{{ 'ADD_PROP_POS' | translate }}">
                    <a class="proportionality_positive" [class.niveau-laag]="effectiefModelleerniveau < 40"></a>
                </li>
                <li class="dl-nodemenu__item" data-uitleg="proportionality_negative" [class.selectedMenuItem]="isActiefInitAddActie('proportionality_negative')" (click)="uitvoerInitAddAction({type:'proportionality_negative'})" title="{{ 'ADD_PROP_NEG' | translate }}">
                    <a class="proportionality_negative" [class.niveau-laag]="effectiefModelleerniveau < 40"></a>
                </li>
            }
            @if (effectiefModelleerniveau >= 50 && (!condtag || condtag.state === 'cons')) {
                <li class="dl-nodemenu__item" data-uitleg="proportionality_multiply" [class.selectedMenuItem]="isActiefInitAddActie('proportionality_multiply')" (click)="uitvoerInitAddAction({type:'proportionality_multiply'})" title="{{ 'ADD_PROP_MULTIPLY' | translate }}">
                    <a class="proportionality_multiply"></a>
                </li>
                <li class="dl-nodemenu__item" data-uitleg="proportionality_divide" [class.selectedMenuItem]="isActiefInitAddActie('proportionality_divide')" (click)="uitvoerInitAddAction({type:'proportionality_divide'})" title="{{ 'ADD_PROP_DIVIDE' | translate }}">
                    <a class="proportionality_divide"></a>
                </li>
            }
        </ul>
    }
    @if (actievSubmenu() === 'quantity_ineq_menu') {
        <ul class="dl-nodemenu__submenu">
            <li class="dl-nodemenu__item" data-uitleg="q_ineq_lt" [class.selectedMenuItem]="isActiefInitAddActie('q_ineq_lt')" (click)="uitvoerInitAddAction({type: 'q_ineq_lt'})" title="{{ 'ADD_INEQ_LT' | translate }}">
                <a class="q_ineq_lt"></a>
            </li>
            <li class="dl-nodemenu__item" data-uitleg="q_ineq_lte" [class.selectedMenuItem]="isActiefInitAddActie('q_ineq_lte')" (click)="uitvoerInitAddAction({type: 'q_ineq_lte'})" title="{{ 'ADD_INEQ_LTE' | translate }}">
                <a class="q_ineq_lte"></a>
            </li>
            <li class="dl-nodemenu__item" data-uitleg="q_ineq_eq" [class.selectedMenuItem]="isActiefInitAddActie('q_ineq_eq')" (click)="uitvoerInitAddAction({type: 'q_ineq_eq'})" title="{{ 'ADD_INEQ_EQ' | translate }}">
                <a class="q_ineq_eq"></a>
            </li>
            <li class="dl-nodemenu__item" data-uitleg="q_ineq_gte" [class.selectedMenuItem]="isActiefInitAddActie('q_ineq_gte')" (click)="uitvoerInitAddAction({type: 'q_ineq_gte'})" title="{{ 'ADD_INEQ_GTE' | translate }}">
                <a class="q_ineq_gte"></a>
            </li>
            <li class="dl-nodemenu__item" data-uitleg="q_ineq_gt" [class.selectedMenuItem]="isActiefInitAddActie('q_ineq_gt')" (click)="uitvoerInitAddAction({type: 'q_ineq_gt'})" title="{{ 'ADD_INEQ_GT' | translate }}">
                <a class="q_ineq_gt"></a>
            </li>
        </ul>
    }
    @if (actievSubmenu() === 'q_calc_menu') {
        <ul class="dl-nodemenu__submenu">
            <li class="dl-nodemenu__item" data-uitleg="q_calc_plus" [class.selectedMenuItem]="isActiefInitAddActie('q_calc_plus')" (click)="uitvoerInitAddAction({type: 'q_calc_plus'})" title="{{ 'ADD_CALC_PLUS' | translate }}">
                <a class="q_calc_plus"></a>
            </li>
            <li class="dl-nodemenu__item" data-uitleg="q_calc_min" [class.selectedMenuItem]="isActiefInitAddActie('q_calc_min')" (click)="uitvoerInitAddAction({type: 'q_calc_min'})" title="{{ 'ADD_CALC_MIN' | translate }}">
                <a class="q_calc_min"></a>
            </li>
            @if (effectiefModelleerniveau >= 50) {
                <li class="dl-nodemenu__item" data-uitleg="q_calc_mult" [class.selectedMenuItem]="isActiefInitAddActie('q_calc_mult')" (click)="uitvoerInitAddAction({type: 'q_calc_mult'})" title="{{ 'ADD_CALC_MULT' | translate }}">
                    <a class="q_calc_mult"></a>
                </li>
                <li class="dl-nodemenu__item" data-uitleg="q_calc_div" [class.selectedMenuItem]="isActiefInitAddActie('q_calc_div')" (click)="uitvoerInitAddAction({type: 'q_calc_div'})" title="{{ 'ADD_CALC_DIV' | translate }}">
                    <a class="q_calc_div"></a>
                </li>
            }
        </ul>
    }
    @if (actievSubmenu() === 'quantity_exogeen_menu') {
        <ul class="dl-nodemenu__submenu">
            @if (!condtag) {
                <li class="dl-nodemenu__item" data-uitleg="q_exo_decr" (click)="uitvoerToggleExogeen('q_exo_decr')" title="{{ 'ADD_EXO_DECR' | translate }}">
                    <a class="q_exo_menuitem q_exo_decr"></a>
                </li>
                <li class="dl-nodemenu__item" data-uitleg="q_exo_steady" (click)="uitvoerToggleExogeen('q_exo_steady')" title="{{ 'ADD_EXO_STEADY' | translate }}">
                    <a class="q_exo_menuitem q_exo_steady"></a>
                </li>
                <li class="dl-nodemenu__item" data-uitleg="q_exo_incr" (click)="uitvoerToggleExogeen('q_exo_incr')" title="{{ 'ADD_EXO_INCR' | translate }}">
                    <a class="q_exo_menuitem q_exo_incr"></a>
                </li>
                <li class="dl-nodemenu__item" data-uitleg="q_exo_sin" (click)="uitvoerToggleExogeen('q_exo_sin')" title="{{ 'ADD_EXO_SIN' | translate }}">
                    <a class="q_exo_menuitem q_exo_sin"></a>
                </li>
                <li class="dl-nodemenu__item" data-uitleg="q_exo_para_pos" (click)="uitvoerToggleExogeen('q_exo_para_pos')" title="{{ 'ADD_EXO_PARA_POS' | translate }}">
                    <a class="q_exo_menuitem q_exo_para_pos"></a>
                </li>
                <li class="dl-nodemenu__item" data-uitleg="q_exo_para_neg" (click)="uitvoerToggleExogeen('q_exo_para_neg')" title="{{ 'ADD_EXO_PARA_NEG' | translate }}">
                    <a class="q_exo_menuitem q_exo_para_neg"></a>
                </li>
                <li class="dl-nodemenu__item" data-uitleg="q_exo_random" (click)="uitvoerToggleExogeen('q_exo_random')" title="{{ 'ADD_EXO_RAND' | translate }}">
                    <a class="q_exo_menuitem q_exo_random"></a>
                </li>
            }
        </ul>
    }
</div>
